export enum PermissionsEnum {
  StartSurvey = "StartSurvey",
  ViewSurvey = "ViewSurvey",
  EditSurvey = "EditSurvey",
  MoveBuildingToBlock = "MoveBuildingToBlock",
  RemoveBuildingsFromBuildingGroup = "RemoveBuildingsFromBuildingGroup",
  AddBuildingsToBuildingGroup = "AddBuildingsToBuildingGroup",
  CreateBuilding = "CreateBuilding",
  ValidateSurvey = "ValidateSurvey",
  AssignSurveyToMe = "AssignSurveyToMe",
  SetSurveyBackToOngoing = "SetSurveyBackToOngoing",
  ReassignAddress = "ReassignAddress",
  DeleteAddress = "DeleteAddress",
  ReassignSurvey = "ReassignSurvey",
  SurveyHistory = "SurveyHistory",
  UserManager = "UserManager",
  ViewCommandUploads = "ViewCommandUploads",
  EditDocumentList = "EditDocumentList",
  PrintDocuments = "PrintDocuments",
  EditContacts = "EditContacts",
  EditMainDistribution = "EditMainDistribution",
  EditAreaContacts = "EditAreaContacts",
  RetryCommand = "RetryCommand",
  RestartCommand = "RestartCommand",
  ExportFieldsConfiguration = "ExportFieldsConfiguration",
  BulkConfiguration = "BulkConfiguration",
  PrefillSurvey = "PrefillSurvey",
  TriggerInitialLoad = "TriggerInitialLoad",
  ViewTemplates = "ViewTemplates",
  ManageDocumentTemplates = "ManageDocumentTemplates",
  ExportLstData = "ExportLstData",
  LomImport = "LomImport",
  BulkUpload = "BulkUpload",
  RefreshBuilding = "RefreshBuilding",
  ForceStartSurvey = "ForceStartSurvey",
  OpenEmptyBuildingsList = "OpenEmptyBuildingList",
  ForceRollBack = "ForceRollBack",
  Settings = "Settings",
  GeneralSettings = "GeneralSettings",
  MaintenanceMessages = "MaintenanceMessages"
}
